import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/ic-exit-rounded-purple.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/icons/info.svg';

interface FreeSampleHeaderProps {
  onClose: () => void;
}

// Cabeçalho persistente do drawer/modal de amostra grátis (Figma, nó 5047-78) — título + ícone de
// info + subtítulo aparecem em toda tela do fluxo (catálogo, detalhe de marca, consentimento,
// interesse, sucesso, empty state), não só na primeira. Fica de fora só a variante mobile (usa
// seta de voltar no lugar) e a tela de erro (segue o padrão do PspErrorStep, sem subtítulo).
const FreeSampleHeader: React.FC<FreeSampleHeaderProps> = ({ onClose }) => (
  <Box flexShrink={0} borderBottom={'1px solid #E9ECEF'}>
    <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'flex-start'} padding={'20px'}>
      <Box>
        <Flex alignItems={'center'} gap={'6px'}>
          <Text fontSize={'18px'} fontWeight={700} color={'#343A40'}>
            Amostra grátis
          </Text>
          <InfoIcon width={'14px'} height={'14px'} />
        </Flex>
        <Text fontSize={'13px'} color={'#6C757D'}>
          Peça ao laboratório e receba no seu consultório
        </Text>
      </Box>
      <CloseIcon onClick={onClose} cursor={'pointer'} />
    </Flex>
  </Box>
);

export default FreeSampleHeader;
